const BACKEND_ORIGIN = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * Turns a relative upload path like "/uploads/abc.jpg" into an absolute URL
 * using the same origin as the backend API. If the URL is already absolute,
 * it is returned unchanged.
 */
export function resolveMediaUrl(url: string | null | undefined): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BACKEND_ORIGIN}${url}`;
}
